<template>
  <article id="About">
    <AboutUs />
  </article>
</template>

<script>
import AboutUs from "../components/AboutUs.vue";

export default {
  name: "AboutPage",
  components: {
    AboutUs,
  },
};
</script>
